<template>
	<view class="box">
		<view class="box_cate">
			<view class="box_cate_item" v-for="(item, index) in cate" :key="index" @click="changeItem(index)">
				<text :class="i === index ? 'active' : ''">{{item}}</text>
				<view class="box_cate_item_x" v-if="i === index"></view>
			</view>
		</view>
		<view class="box_list">
			<view class="box_list_item" @click="jump">
				<view class="ordernum">
					<text>订单编号：18293482938429348</text>
					<text>待收货</text>
				</view>
				<view class="info">
					<view class="info_img">
						<image src="@/static/uni.png" mode="widthFix"></image>
					</view>
					<view class="info_desc">
						<view class="info_desc_a">
							<view class="info_desc_title">清澄白河马克杯-节日版清澄白河马克杯-节日版</view>
							<view class="info_desc_price">
								<text>¥</text>
								<text>79</text>
								<text>.98</text>
							</view>
						</view>
						<view class="info_desc_b">
							<text>白色</text>
							<text>x1</text>
						</view>
						<view class="info_desc_c">退款中</view>
					</view>
				</view>
				<view class="info">
					<view class="info_img">
						<image src="@/static/uni.png" mode="widthFix"></image>
					</view>
					<view class="info_desc">
						<view class="info_desc_a">
							<view class="info_desc_title">清澄白河马克杯-节日版清澄白河马克杯-节日版</view>
							<view class="info_desc_price">
								<text>¥</text>
								<text>79</text>
								<text>.98</text>
							</view>
						</view>
						<view class="info_desc_b">
							<text>白色</text>
							<text>x1</text>
						</view>
					</view>
				</view>
				<view class="logistics">
					<view class="logistics_left">
						<image src="@/static/icon/ic_yunshu@2x.png" mode="widthFix"></image>
						<text>运输中</text>
					</view>
					<view class="logistics_right">邮政快递包裹：已到达【上海市青浦区】递包裹</view>
				</view>
				<view class="price">
					<view class="price_label">实付款</view>
					<view class="price_num">
						<text>¥</text>
						<text>79</text>
						<text>.98</text>
					</view>
				</view>
				<view class="submit">
					<view class="submit_dele">查看物流</view>
					<view class="submit_addcar">确认收货</view>
				</view>
			</view>
			<view class="box_list_item" @click="jump">
				<view class="ordernum">
					<text>订单编号：18293482938429348</text>
					<text>交易关闭</text>
				</view>
				<view class="info">
					<view class="info_img">
						<image src="@/static/uni.png" mode="widthFix"></image>
					</view>
					<view class="info_desc">
						<view class="info_desc_a">
							<view class="info_desc_title">清澄白河马克杯-节日版清澄白河马克杯-节日版</view>
							<view class="info_desc_price">
								<text>¥</text>
								<text>79</text>
								<text>.98</text>
							</view>
						</view>
						<view class="info_desc_b">
							<text>白色</text>
							<text>x1</text>
						</view>
						<view class="info_desc_c">退款成功</view>
					</view>
				</view>
				<view class="price">
					<view class="price_label">实付款</view>
					<view class="price_num">
						<text>¥</text>
						<text>79</text>
						<text>.98</text>
					</view>
				</view>
				<view class="submit">
					<view class="submit_dele" @click="openDele">删除订单</view>
					<view class="submit_addcar" @click="addshopCart">加购物车</view>
				</view>
			</view>
			<view class="box_list_item" @click="jump">
				<view class="ordernum">
					<text>订单编号：18293482938429348</text>
					<text>待支付</text>
				</view>
				<view class="info">
					<view class="info_img">
						<image src="@/static/uni.png" mode="widthFix"></image>
					</view>
					<view class="info_desc">
						<view class="info_desc_a">
							<view class="info_desc_title">清澄白河马克杯-节日版清澄白河马克杯-节日版</view>
							<view class="info_desc_price">
								<text>¥</text>
								<text>79</text>
								<text>.98</text>
							</view>
						</view>
						<view class="info_desc_b">
							<text>白色</text>
							<text>x1</text>
						</view>
					</view>
				</view>
				<view class="price">
					<view class="price_label">实付款</view>
					<view class="price_num">
						<text>¥</text>
						<text>79</text>
						<text>.98</text>
					</view>
				</view>
				<view class="submit">
					<view class="submit_dele" @click="openOrder">取消订单</view>
					<view class="submit_dele" @click="toaddress">修改地址</view>
					<view class="submit_addcar" @click="addshopCart">加购物车</view>
				</view>
			</view>
			<view class="box_list_item" @click="jump">
				<view class="ordernum">
					<text>订单编号：18293482938429348</text>
					<text>待发货</text>
				</view>
				<view class="info">
					<view class="info_img">
						<image src="@/static/uni.png" mode="widthFix"></image>
					</view>
					<view class="info_desc">
						<view class="info_desc_a">
							<view class="info_desc_title">清澄白河马克杯-节日版清澄白河马克杯-节日版</view>
							<view class="info_desc_price">
								<text>¥</text>
								<text>79</text>
								<text>.98</text>
							</view>
						</view>
						<view class="info_desc_b">
							<text>白色</text>
							<text>x1</text>
						</view>
					</view>
				</view>
				<view class="price">
					<view class="price_label">实付款</view>
					<view class="price_num">
						<text>¥</text>
						<text>79</text>
						<text>.98</text>
					</view>
				</view>
				<view class="submit">
					<view class="submit_dele" @click="toaddress">修改地址</view>
					<view class="submit_addcar">催发货</view>
				</view>
			</view>
			<view class="box_list_item" @click="jump">
				<view class="ordernum">
					<text>订单编号：18293482938429348</text>
					<text>交易完成</text>
				</view>
				<view class="info">
					<view class="info_img">
						<image src="@/static/uni.png" mode="widthFix"></image>
					</view>
					<view class="info_desc">
						<view class="info_desc_a">
							<view class="info_desc_title">清澄白河马克杯-节日版清澄白河马克杯-节日版</view>
							<view class="info_desc_price">
								<text>¥</text>
								<text>79</text>
								<text>.98</text>
							</view>
						</view>
						<view class="info_desc_b">
							<text>白色</text>
							<text>x1</text>
						</view>
					</view>
				</view>
				<view class="price">
					<view class="price_label">实付款</view>
					<view class="price_num">
						<text>¥</text>
						<text>79</text>
						<text>.98</text>
					</view>
				</view>
				<view class="submit">
					<view class="submit_dele" @click="addshopCart">加购物车</view>
					<view class="submit_dele">查看物流</view>
					<view class="submit_addcar">评价</view>
				</view>
			</view>
		</view>
		<!-- 加入购物车成功 -->
		<uni-popup ref="popup" background-color="#fff">
			<view class="popup">
				<view class="popup_head">
				<uni-icons type="closeempty" size="20" color="#999999" @click="cartClose"></uni-icons>
				</view>
				<view class="popup_info">
					<image src="@/static/icon/ic_success@2x.png" mode="widthFix"></image>
					<text class="popup_info_a">成功加入购物车</text>
					<text class="popup_info_b">可以前往购物车去结算啦～</text>
				</view>
				<view class="popup_footer">
					<view class="popup_footer_btn">去购物车结算</view>
				</view>
			</view>
		</uni-popup>
		<!-- 取消订单 -->
		<uni-popup ref="popup1" background-color="#fff">
			<view class="popup1">
				<view class="popup_head">
					<text></text>
					<text>取消订单</text>
					<uni-icons type="closeempty" @click="close" size="20" color="#999999"></uni-icons>
				</view>
				<view class="popup_list">
					<view class="popup_list_item" v-for="(item, index) in cates" :key="index" @click="changeCate(index)">
						<text>{{item.name}}</text>
						<radio color="#D20A0A" :value="item.id" :checked="index === current" />
					</view>
				</view>
				<view class="popup_footer">
					<view class="popup_footer_btn">
						<view class="popup_footer_btn_left" @click="close">暂不取消</view>
						<view class="popup_footer_btn_right" @click="define">确定取消</view>
					</view>
				</view>
			</view>
		</uni-popup>
		<!-- 删除订单 -->
		<uni-popup ref="popup2" background-color="#fff">
			<view class="popup2">
				<view class="popup_text">确认删除订单？</view>
				<view class="popup_box">
					<view class="popup_box_item" @click="closeDele">取消</view>
					<view class="popup_box_item">确认</view>
				</view>
			</view>
		</uni-popup>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				i: 0,
				current: 0,
				from: {
					name: '',
					val: ''
				},
				cate: ['全部', '待支付', '待发货', '待收货', '待评价'],
				cates: [
					{ name: '价格有点贵', id: 1 },
					{ name: '规格/款式/数量拍错', id: 2 },
					{ name: '暂时不需要', id: 3 },
					{ name: '其他', id: 4 }
				]
			}
		},
		methods: {
			changeItem(index) {
				this.i = index;
			},
			addshopCart() {
				this.$refs.popup.open('bottom')
			},
			cartClose() {
				this.$refs.popup.close()
			},
			openOrder() {
				this.$refs.popup1.open('bottom')
			},
			close() {
				this.$refs.popup1.close()
			},
			changeCate(index) {
				this.current = index
			},
			define() {
				this.from.name = this.cates[this.current].name
				this.from.val = this.cates[this.current].id
				this.$refs.popup.close()
			},
			openDele() {
				this.$refs.popup2.open('center')
			},
			closeDele() {
				this.$refs.popup2.close()
			},
			toaddress() {
				uni.navigateTo({
					url: '/pages/modifyAddress/index'
				});
			},
			jump() {
				uni.navigateTo({
					url: '/pages/orderDetails/index'
				});
			}
		}
	}
</script>

<style>
	.uni-popup__wrapper {
		border-radius: 24rpx !important;
	}
</style>

<style lang="scss" scoped>
	.box {
		width: 100%;
		.box_cate {
			width: 100%;
			height: 84rpx;
			display: flex;
			align-items: center;
			position: sticky;
			top: 0;
			left: 0;
			background: #FFFFFF;
			border: 2rpx solid #F4F5F4;
			.box_cate_item {
				flex: 1;
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				flex-direction: column;
				.active {
					font-size: 32rpx !important;
					font-weight: 500 !important;
					color: #333333 !important;
				}
				text {
					font-size: 28rpx;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #666666;
				}
				.box_cate_item_x {
					width: 40rpx;
					height: 4rpx;
					background: #D20A0A;
					border-radius: 12rpx;
					margin-top: 8rpx;
				}
			}
		}
		.box_list {
			width: 100%;
			display: flex;
			flex-direction: column;
			.box_list_item {
				display: flex;
				flex-direction: column;
				background-color: #FFFFFF;
				padding: 28rpx 32rpx;
				box-sizing: border-box;
				.ordernum {
					display: flex;
					align-items: center;
					justify-content: space-between;
					text {
						&:first-child {
							font-size: 26rpx;
							font-family: PingFang SC-Regular, PingFang SC;
							font-weight: 400;
							color: #666666;
						}
						&:last-child {
							font-size: 28rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #666666;
						}
					}
				}
				.info {
					display: flex;
					align-content: flex-start;
					margin-top: 46rpx;
					&:nth-child(3) {
						margin-top: 28rpx !important;
					}
					.info_img {
						flex-shrink: 0;
						width: 180rpx;
						height: 180rpx;
						background: #FFFFFF;
						border-radius: 12rpx;
						border: 2rpx solid #F5F5F5;
						display: flex;
						align-items: center;
						justify-content: center;
						margin-right: 20rpx;
						image {
							width: 160rpx;
							height: 160rpx;
						}
					}
					.info_desc {
						flex: 1;
						height: 100%;
						display: flex;
						flex-direction: column;
						.info_desc_a {
							display: flex;
							align-items: center;
							justify-content: space-between;
							.info_desc_title {
								width: 320rpx;
								font-size: 28rpx;
								font-family: PingFang SC-Medium, PingFang SC;
								font-weight: 500;
								color: #333333;
								white-space: nowrap;
								overflow: hidden;
								text-overflow: ellipsis;
							}
							.info_desc_price {
								display: flex;
								align-items: center;
								text {
									&:nth-child(1) {
										font-size: 20rpx;
										font-family: PingFang SC-Semibold, PingFang SC;
										font-weight: 600;
										color: #333333;
										margin-top: 11rpx;
									}
									&:nth-child(2) {
										font-size: 28rpx;
										font-family: PingFang SC-Semibold, PingFang SC;
										font-weight: 600;
										color: #333333;
									}
									&:nth-child(3) {
										font-size: 20rpx;
										font-family: PingFang SC-Semibold, PingFang SC;
										font-weight: 600;
										color: #333333;
										margin-top: 11rpx;
									}
								}
							}
						}
						.info_desc_b {
							display: flex;
							align-items: center;
							justify-content: space-between;
							margin-top: 16rpx;
							text {
								font-size: 28rpx;
								font-family: PingFang SC-Medium, PingFang SC;
								font-weight: 500;
								color: #999999;
							}
						}
						.info_desc_c {
							margin-top: 16rpx;
							text-align: right;
							width: 100%;
							font-size: 28rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #D20A0A;
						}
					}
				}
				.logistics {
					width: 100%;
					height: 68rpx;
					background: #F5F5F5;
					border-radius: 12rpx;
					margin: 28rpx 0;
					display: flex;
					align-items: center;
					padding: 0 24rpx;
					box-sizing: border-box;
					.logistics_left {
						flex: 1;
						display: flex;
						align-items: center;
						image {
							width: 31rpx;
							height: 26rpx;
							margin-right: 16rpx;
						}
						text {
							font-size: 28rpx;
							font-family: PingFang SC-Semibold, PingFang SC;
							font-weight: 600;
							color: #333333;
						}
					}
					.logistics_right {
						width: 504rpx;
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
						font-size: 28rpx;
						font-family: PingFang SC-Regular, PingFang SC;
						font-weight: 400;
						color: #333333;
					}
				}
				.price {
					width: 100%;
					display: flex;
					justify-content: flex-end;
					.price_label {
						font-size: 28rpx;
						font-family: PingFang SC-Semibold, PingFang SC;
						font-weight: 600;
						color: #333333;
					}
					.price_num {
						display: flex;
						align-items: center;
						text {
							&:nth-child(1) {
								font-size: 20rpx;
								font-family: PingFang SC-Semibold, PingFang SC;
								font-weight: 600;
								color: #333333;
								margin-top: 6rpx;
							}
							&:nth-child(2) {
								font-size: 28rpx;
								font-family: PingFang SC-Semibold, PingFang SC;
								font-weight: 600;
								color: #333333;
							}
							&:nth-child(3) {
								font-size: 20rpx;
								font-family: PingFang SC-Semibold, PingFang SC;
								font-weight: 600;
								color: #333333;
								margin-top: 6rpx;
							}
						}
					}
				}
				.submit {
					width: 100%;
					margin-top: 48rpx;
					display: flex;
					align-items: center;
					justify-content: flex-end;
					.submit_dele {
						width: 144rpx;
						height: 52rpx;
						line-height: 52rpx;
						text-align: center;
						border-radius: 30rpx;
						border: 2rpx solid #D9D9D9;
						font-size: 28rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #333333;
						margin-right: 16rpx;
					}
					.submit_addcar {
						width: 144rpx;
						height: 52rpx;
						line-height: 52rpx;
						text-align: center;
						border-radius: 30rpx 30rpx 30rpx 30rpx;
						border: 2rpx solid #D20A0A;
						font-size: 28rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #D20A0A;
					}
				}
			}
		}
		.popup {
			padding: 44rpx 32rpx 20rpx 32rpx;
			box-sizing: border-box;
			background-color: #FFFFFF;
			width: 100%;
			.popup_head {
				display: flex;
				justify-content: flex-end;
			}
			.popup_info {
				margin-top: 36rpx;
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				flex-direction: column;
				image {
					width: 136rpx;
					height: 136rpx;
				}
				.popup_info_a {
					font-size: 36rpx;
					font-family: PingFang SC-Semibold, PingFang SC;
					font-weight: 600;
					color: #333333;
					margin-top: 60rpx;
				}
				.popup_info_b {
					font-size: 28rpx;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #999999;
					margin-top: 40rpx;
				}
			}
			.popup_footer {
				width: 100%;
				padding: 0 24rpx;
				box-sizing: border-box;
				margin-top: 160rpx;
				.popup_footer_btn {
					width: 100%;
					height: 72rpx;
					line-height: 72rpx;
					text-align: center;
					font-size: 32rpx;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #FFFFFF;
					background: linear-gradient(90deg, #D95A5A 0%, #D20A0A 100%);
					border-radius: 36rpx;
				}
			}
		}
		.popup1 {
			padding: 48rpx 32rpx 0 32rpx;
			.popup_head {
				display: flex;
				align-items: center;
				justify-content: space-between;
				text {
					font-size: 32rpx;
					font-family: PingFang SC-Semibold, PingFang SC;
					font-weight: 600;
					color: #333333;
				}
			}
			.popup_list {
				width: 100%;
				display: flex;
				flex-direction: column;
				margin-top: 68rpx;
				.popup_list_item {
					display: flex;
					align-items: center;
					justify-content: space-between;
					margin-bottom: 62rpx;
					&:last-child {
						margin-bottom: 0 !important;
					}
					text {
						font-size: 28rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #333333;
					}
				}
			}
			.popup_footer {
				padding: 0 56rpx;
				margin-top: 112rpx;
				.popup_footer_btn {
					width: 100%;
					height: 72rpx;
					background: linear-gradient(270deg, #D20A0A 0%, #D95A5A 100%);
					border-radius: 36rpx;
					overflow: hidden;
					display: flex;
					align-items: center;
					.popup_footer_btn_left {
						flex: 1;
						height: 100%;
						display: flex;
						align-items: center;
						justify-content: center;
						background: #D95A5A;
						font-size: 32rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #FFFFFF;
					}
					.popup_footer_btn_right {
						flex: 1;
						height: 100%;
						display: flex;
						align-items: center;
						justify-content: center;
						background: #D20A0A;
						font-size: 32rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #FFFFFF;
					}
				}
			}
		}
		.popup2 /deep/ {
			width: 518rpx;
			background: #FFFFFF;
			border-radius: 24rpx;
			.popup_text {
				width: 100%;
				text-align: center;
				margin: 46rpx 0;
				font-size: 32rpx;
				font-family: PingFang SC-Semibold, PingFang SC;
				font-weight: 600;
				color: #333333;
			}
			.popup_box {
				width: 100%;
				height: 85rpx;
				display: flex;
				align-items: center;
				border-top: 2rpx solid #C8C8C8;
				.popup_box_item {
					flex: 1;
					height: 100%;
					display: flex;
					align-items: center;
					justify-content: center;
					font-size: 32rpx;
					font-family: PingFang SC-Semibold, PingFang SC;
					font-weight: 600;
					color: #333333;
					&:first-child {
						border-right: 2rpx solid #C8C8C8;
					}
				}
			}
		}
	}
</style>